export const LANGUAGE_OPTIONS = [
  { label: 'Afrikaans', value: 'af' },
  { label: 'Albanian', value: 'sq' },
  { label: 'Amharic', value: 'am' },
  { label: 'Arabic (Saudi Arabia)', value: 'ar-sa' },
  { label: 'Arabic (Algeria)', value: 'ar-dz' },
  { label: 'Arabic (Egypt)', value: 'ar-eg' },
  { label: 'Arabic (Iraq)', value: 'ar-iq' },
  { label: 'Arabic (Jordan)', value: 'ar-jo' },
  { label: 'Arabic (Kuwait)', value: 'ar-kw' },
  { label: 'Arabic (Lebanon)', value: 'ar-lb' },
  { label: 'Arabic (Morocco)', value: 'ar-ma' },
  { label: 'Arabic (Qatar)', value: 'ar-qa' },
  { label: 'Arabic (Tunisia)', value: 'ar-tn' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Assamese', value: 'as' },
  { label: 'Azerbaijani (Latin)', value: 'az-latn' },
  { label: 'Bangla (Bangladesh)', value: 'bn-bd' },
  { label: 'Bangla (India)', value: 'bn-in' },
  { label: 'Basque', value: 'eu' },
  { label: 'Belarusian', value: 'be' },
  { label: 'Bashkir', value: 'ba' },
  { label: 'Bosnian (Latin)', value: 'bs' },
  { label: 'Breton', value: 'br' },
  { label: 'Bulgarian', value: 'bg' },
  { label: 'Burmese', value: 'my' },
  { label: 'Catalan Spanish', value: 'ca' },
  { label: 'Central Kurdish', value: 'ku-arab' },
  { label: 'Cherokee', value: 'chr' },
  { label: 'Chinese (Simplified)', value: 'zh-hans' },
  { label: 'Chinese (Simplified, China)', value: 'zh-cn' },
  { label: 'Chinese (Simplified, Singapore)', value: 'zh-sg' },
  { label: 'Chinese (Traditional)', value: 'zh-hant' },
  { label: 'Chinese (Traditional, Hong Kong)', value: 'zh-hk' },
  { label: 'Chinese (Traditional, Macau)', value: 'zh-mo' },
  { label: 'Chinese (Traditional, Taiwan)', value: 'zh-tw' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Czech', value: 'cs' },
  { label: 'Danish', value: 'da' },
  { label: 'Dari', value: 'prs-arab' },
  { label: 'Divehi', value: 'dv' },
  { label: 'Dutch (Netherlands)', value: 'nl' },
  { label: 'English (Australia)', value: 'en-au' },
  { label: 'English (Canada)', value: 'en-ca' },
  { label: 'English (India)', value: 'en-in' },
  { label: 'English (New Zealand)', value: 'en-nz' },
  { label: 'English (South Africa)', value: 'en-za' },
  { label: 'English (United Kingdom)', value: 'en-gb' },
  { label: 'English (United States)', value: 'en-us' },
  { label: 'Esperanto', value: 'eo' },
  { label: 'Estonian', value: 'et' },
  { label: 'Faroese', value: 'fo' },
  { label: 'Filipino', value: 'fil-latn' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French (Belgium)', value: 'fr-be' },
  { label: 'French (Canada)', value: 'fr-ca' },
  { label: 'French (France)', value: 'fr' },
  { label: 'French (Switzerland)', value: 'fr-ch' },
  { label: 'Galician', value: 'gl' },
  { label: 'Georgian', value: 'ka' },
  { label: 'German (Austria)', value: 'de-at' },
  { label: 'German (Germany)', value: 'de' },
  { label: 'German (Switzerland)', value: 'de-ch' },
  { label: 'Greek', value: 'el' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Hausa (Latin)', value: 'ha-latn' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Icelandic', value: 'is' },
  { label: 'Igbo', value: 'ig-latn' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Irish', value: 'ga' },
  { label: 'isiXhosa', value: 'xh' },
  { label: 'isiZulu', value: 'zu' },
  { label: 'Italian (Italy)', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Javanese', value: 'jv' },
  { label: 'Kannada', value: 'kn' },
  { label: 'Kashmiri', value: 'ks' },
  { label: 'Kazakh', value: 'kk' },
  { label: 'Khmer', value: 'km' },
  { label: 'Kinyarwanda', value: 'rw' },
  { label: 'Kiswahili', value: 'sw' },
  { label: 'Kiswahili (Kenya)', value: 'sw-ke' },
  { label: 'Kiswahili (Tanzania)', value: 'sw-tz' },
  { label: 'Konkani', value: 'kok' },
  { label: 'Korean', value: 'ko' },
  { label: 'Kyrgyz', value: 'ky-cyrl' },
  { label: 'Lingala', value: 'ln' },
  { label: 'Latvian', value: 'lv' },
  { label: 'Lithuanian', value: 'lt' },
  { label: 'Luxembourgish', value: 'lb' },
  { label: 'Macedonian', value: 'mk' },
  { label: 'Malay (Malaysia)', value: 'ms' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Maltese', value: 'mt' },
  { label: 'Maori', value: 'mi-latn' },
  { label: 'Mapudungun', value: 'arn' },
  { label: 'Malagasy', value: 'mg' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Mongolian (Cyrillic)', value: 'mn-cyrl' },
  { label: 'Nepali (Nepal)', value: 'ne' },
  { label: 'Norwegian (Bokmål)', value: 'nb' },
  { label: 'Norwegian (Nynorsk)', value: 'nn' },
  { label: 'Odia', value: 'or' },
  { label: 'Pashto', value: 'ps' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese (Angola)', value: 'pt-ao' },
  { label: 'Portuguese (Brazil)', value: 'pt-br' },
  { label: 'Portuguese (Mozambique)', value: 'pt-mz' },
  { label: 'Portuguese (Portugal)', value: 'pt-pt' },
  { label: 'Punjabi (Arabic)', value: 'pa-arab' },
  { label: 'Punjabi (Gurmukhi)', value: 'pa' },
  { label: 'Quechua (Peru)', value: 'quz' },
  { label: 'Romanian (Romania)', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Samoan', value: 'sm' },
  { label: 'Sanskrit', value: 'sa' },
  { label: 'Scottish Gaelic', value: 'gd-latn' },
  {
    label: 'Serbian (Cyrillic, Bosnia and Herzegovina)',
    value: 'sr-cyrl-ba',
  },
  { label: 'Serbian (Cyrillic, Serbia)', value: 'sr-cyrl-rs' },
  { label: 'Serbian (Latin, Serbia)', value: 'sr-latn-rs' },
  { label: 'Sesotho sa Leboa', value: 'nso' },
  { label: 'Setswana', value: 'tn' },
  { label: 'Sindhi (Arabic)', value: 'sd-arab' },
  { label: 'Sinhala', value: 'si' },
  { label: 'Sichuan Yi', value: 'ii' },
  { label: 'Slovak', value: 'sk' },
  { label: 'Slovenian', value: 'sl' },
  { label: 'Somali', value: 'so' },
  { label: 'Spanish (Argentina)', value: 'es-ar' },
  { label: 'Spanish (Bolivia)', value: 'es-bo' },
  { label: 'Spanish (Chile)', value: 'es-cl' },
  { label: 'Spanish (Colombia)', value: 'es-co' },
  { label: 'Spanish (Ecuador)', value: 'es-ec' },
  { label: 'Spanish (Mexico)', value: 'es-mx' },
  { label: 'Spanish (Peru)', value: 'es-pe' },
  { label: 'Spanish (Spain)', value: 'es' },
  { label: 'Spanish (United States)', value: 'es-us' },
  { label: 'Spanish (Uruguay)', value: 'es-uy' },
  { label: 'Spanish (Venezuela)', value: 'es-ve' },
  { label: 'Sundanese', value: 'su' },
  { label: 'Swedish (Sweden)', value: 'sv' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Tajik (Cyrillic)', value: 'tg-cyrl' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Tatar (Cyrillic)', value: 'tt-cyrl' },
  { label: 'Telugu', value: 'te' },
  { label: 'Thai', value: 'th' },
  { label: 'Tibetan', value: 'bo' },
  { label: 'Tigrinya', value: 'ti' },
  { label: 'Tongan', value: 'to' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Turkmen (Latin)', value: 'tk-latn' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Uyghur', value: 'ug-arab' },
  { label: 'Uzbek (Latin)', value: 'uz-latn' },
  { label: 'Valencian', value: 'ca-es-valencia' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Welsh', value: 'cy' },
  { label: 'Western Frisian', value: 'fy' },
  { label: 'Wolof', value: 'wo' },
  { label: 'Yakut', value: 'sah' },
  { label: 'Yoruba', value: 'yo-latn' },
  { label: "K'iche'", value: 'qut-latn' },
  { label: 'Akan', value: 'ak' },
].sort((a, b) => a.label.localeCompare(b.label));

export const LANGUAGE_KEYS = {
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'Amharic',
  'ar-sa': 'Arabic (Saudi Arabia)',
  'ar-dz': 'Arabic (Algeria)',
  'ar-eg': 'Arabic (Egypt)',
  'ar-iq': 'Arabic (Iraq)',
  'ar-jo': 'Arabic (Jordan)',
  'ar-kw': 'Arabic (Kuwait)',
  'ar-lb': 'Arabic (Lebanon)',
  'ar-ma': 'Arabic (Morocco)',
  'ar-qa': 'Arabic (Qatar)',
  'ar-tn': 'Arabic (Tunisia)',
  as: 'Assamese',
  arn: 'Mapudungun',
  'az-latn': 'Azerbaijani (Latin)',
  ba: 'Bashkir',
  be: 'Belarusian',
  bg: 'Bulgarian',
  bo: 'Tibetan',
  br: 'Breton',
  'bn-bd': 'Bangla (Bangladesh)',
  'bn-in': 'Bangla (India)',
  bs: 'Bosnian (Latin)',
  ca: 'Catalan Spanish',
  'ca-es-valencia': 'Valencian',
  chr: 'Cherokee',
  cs: 'Czech',
  cy: 'Welsh',
  da: 'Danish',
  de: 'German (Germany)',
  'de-de': 'German (Germany)',
  'de-at': 'German (Austria)',
  'de-ch': 'German (Switzerland)',
  dv: 'Divehi',
  el: 'Greek',
  'en-gb': 'English (United Kingdom)',
  'en-us': 'English (United States)',
  'en-au': 'English (Australia)',
  'en-ca': 'English (Canada)',
  'en-in': 'English (India)',
  'en-nz': 'English (New Zealand)',
  'en-za': 'English (South Africa)',
  eo: 'Esperanto',
  es: 'Spanish (Spain)',
  'es-es': 'Spanish (Spain)',
  'es-us': 'Spanish (United States)',
  'es-mx': 'Spanish (Mexico)',
  'es-ar': 'Spanish (Argentina)',
  'es-bo': 'Spanish (Bolivia)',
  'es-cl': 'Spanish (Chile)',
  'es-co': 'Spanish (Colombia)',
  'es-ec': 'Spanish (Ecuador)',
  'es-pe': 'Spanish (Peru)',
  'es-uy': 'Spanish (Uruguay)',
  'es-ve': 'Spanish (Venezuela)',
  et: 'Estonian',
  eu: 'Basque',
  fa: 'Persian',
  fi: 'Finnish',
  fo: 'Faroese',
  fy: 'Western Frisian',
  'fil-latn': 'Filipino',
  fr: 'French (France)',
  'fr-fr': 'French (France)',
  'fr-ca': 'French (Canada)',
  'fr-be': 'French (Belgium)',
  'fr-ch': 'French (Switzerland)',
  ga: 'Irish',
  'gd-latn': 'Scottish Gaelic',
  gl: 'Galician',
  gu: 'Gujarati',
  'ha-latn': 'Hausa (Latin)',
  he: 'Hebrew',
  hi: 'Hindi',
  hr: 'Croatian',
  hu: 'Hungarian',
  hy: 'Armenian',
  id: 'Indonesian',
  'ig-latn': 'Igbo',
  ii: 'Sichuan Yi',
  is: 'Icelandic',
  it: 'Italian (Italy)',
  'it-it': 'Italian (Italy)',
  ja: 'Japanese',
  jv: 'Javanese',
  ka: 'Georgian',
  kk: 'Kazakh',
  km: 'Khmer',
  kn: 'Kannada',
  ko: 'Korean',
  kok: 'Konkani',
  ks: 'Kashmiri',
  'ku-arab': 'Central Kurdish',
  'ky-cyrl': 'Kyrgyz',
  lb: 'Luxembourgish',
  ln: 'Lingala',
  lt: 'Lithuanian',
  lv: 'Latvian',
  'mi-latn': 'Maori',
  mk: 'Macedonian',
  ml: 'Malayalam',
  'mn-cyrl': 'Mongolian (Cyrillic)',
  mr: 'Marathi',
  ms: 'Malay (Malaysia)',
  mt: 'Maltese',
  mg: 'Malagasy',
  my: 'Burmese',
  nb: 'Norwegian (Bokmål)',
  ne: 'Nepali (Nepal)',
  nl: 'Dutch (Netherlands)',
  'nl-be': 'Dutch (Netherlands)',
  nn: 'Norwegian (Nynorsk)',
  nso: 'Sesotho sa Leboa',
  or: 'Odia',
  pa: 'Punjabi (Gurmukhi)',
  'pa-arab': 'Punjabi (Arabic)',
  pl: 'Polish',
  ps: 'Pashto',
  'prs-arab': 'Dari',
  'pt-ao': 'Portuguese (Angola)',
  'pt-br': 'Portuguese (Brazil)',
  'pt-mz': 'Portuguese (Mozambique)',
  'pt-pt': 'Portuguese (Portugal)',
  'qut-latn': "K'iche'",
  quz: 'Quechua (Peru)',
  ro: 'Romanian (Romania)',
  ru: 'Russian',
  rw: 'Kinyarwanda',
  sa: 'Sanskrit',
  sah: 'Yakut',
  'sd-arab': 'Sindhi (Arabic)',
  si: 'Sinhala',
  sk: 'Slovak',
  sl: 'Slovenian',
  sm: 'Samoan',
  so: 'Somali',
  sq: 'Albanian',
  su: 'Sundanese',
  'sr-cyrl-ba': 'Serbian (Cyrillic, Bosnia and Herzegovina)',
  'sr-cyrl-rs': 'Serbian (Cyrillic, Serbia)',
  'sr-latn-rs': 'Serbian (Latin, Serbia)',
  sv: 'Swedish (Sweden)',
  sw: 'Kiswahili',
  'sw-ke': 'Swahili (Kenya)',
  'sw-tz': 'Swahili (Tanzania)',
  ta: 'Tamil',
  te: 'Telugu',
  'tg-cyrl': 'Tajik (Cyrillic)',
  th: 'Thai',
  ti: 'Tigrinya',
  'tk-latn': 'Turkmen (Latin)',
  tl: 'Tagalog',
  tn: 'Setswana',
  to: 'Tongan',
  tr: 'Turkish',
  'tt-cyrl': 'Tatar (Cyrillic)',
  'ug-arab': 'Uyghur',
  uk: 'Ukrainian',
  ur: 'Urdu',
  'uz-latn': 'Uzbek (Latin)',
  vi: 'Vietnamese',
  wo: 'Wolof',
  xh: 'isiXhosa',
  'yo-latn': 'Yoruba',
  'zh-hans': 'Chinese (Simplified)',
  'zh-hant': 'Chinese (Traditional)',
  'zh-cn': 'Chinese (Simplified, China)',
  'zh-sg': 'Chinese (Simplified, Singapore)',
  'zh-hk': 'Chinese (Traditional, Hong Kong)',
  'zh-mo': 'Chinese (Traditional, Macau)',
  'zh-tw': 'Chinese (Traditional, Taiwan)',
  zu: 'isiZulu',
};
